'use client';
import TierTwoHero from '@repo/ui/src/components/TierTwoHero';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import HeaderVariety from '../header-variety';
import Button from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { classNames } from '@repo/ui/src/utils/classNames';

const PromoBanner = (props) => {
  const { push } = useModal(ModalID.video);
  const {
    smallBanner,
    title,
    subtitle,
    cta,
    headerVariation,
    videoOrCTA,
    youtubeVideo,
    _testID,
    _meta,
    backgroundImage,
  } = props;

  const linkObj = cta?.length && cta[0];

  return (
    <div
      className={classNames(!smallBanner && 'md:tw-h-[650px]')}
      data-test-id={`promo_banner_${_testID}`}
    >
      <TierTwoHero
        _meta={_meta}
        backgroundImage={backgroundImage}
        headerVariation={headerVariation}
        opacityLayerClass="given-height"
      >
        <div className="tw-text-center">
          <HeaderVariety
            classNames="tw-text-white"
            defaultVariation="h1"
            headerVariation={headerVariation?.headerVariation || 'h1'}
          >
            {title && (
              <span
                className={classNames(
                  'tw-text-white',
                  smallBanner
                    ? 'tw-text-5xl md:tw-text-8xl tw-leading-[45px] md:tw-leading-[85px]'
                    : 'tw-text-7xl md:tw-text-9xl tw-leading-[55px] md:tw-leading-[85px]',
                )}
              >
                {title}
              </span>
            )}
            <br />
            {subtitle && (
              <span
                className={classNames(
                  'tw-text-white tw-relative md:tw-leading-[85px]',
                  smallBanner
                    ? 'tw-text-4xl md:tw-text-8xl tw-leading-[40px] md:-tw-top-5'
                    : 'tw-text-6xl md:tw-text-9xl tw-leading-[50px] md:-tw-top-3',
                )}
              >
                {subtitle}
              </span>
            )}
          </HeaderVariety>

          {videoOrCTA === 'Youtube Modal' && youtubeVideo ? (
            <Button onClick={() => push({ youtubeLink: youtubeVideo })}>Watch Video</Button>
          ) : (
            linkObj && (
              <div className="tw-flex tw-items-center tw-justify-center tw-align-middle">
                <Button className="tw-max-w-[200px]" link={linkObj.link} as={Anchor}>
                  {linkObj.displayName}
                </Button>
              </div>
            )
          )}
        </div>
      </TierTwoHero>
    </div>
  );
};

export default PromoBanner;
